(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.menu-filter__summary').forEach((btn) => {
    btn.addEventListener('click', () => {
      const accordion = btn.closest('.menu-filter__accordion');
      if (!accordion) return;
      const isOpen = accordion.dataset.open === 'true';
      const nowOpen = !isOpen;

      accordion.dataset.open = String(nowOpen);
      btn.setAttribute('aria-expanded', String(nowOpen));
      const sublist = accordion.querySelector('.menu-filter__sublist');
      if (sublist) sublist.setAttribute('aria-hidden', String(!nowOpen));

      if (nowOpen) {
        const scrollArea = accordion.closest('.nm-menu-scroll-area');
        if (!scrollArea || !sublist) return;
        requestAnimationFrame(() => {
          const areaBottom = scrollArea.getBoundingClientRect().bottom;
          const sublistBottom = sublist.getBoundingClientRect().bottom;
          if (sublistBottom > areaBottom) {
            scrollArea.scrollBy({ top: sublistBottom - areaBottom + 16, behavior: 'smooth' });
          }
        });
      }
    });
  });

  // Reset filter accordions when the menu drawer closes
  const menuContainer = document.querySelector('#Details-menu-drawer-container');
  if (menuContainer) {
    menuContainer.addEventListener('toggle', () => {
      if (!menuContainer.open) {
        document.querySelectorAll('.menu-filter__accordion').forEach((acc) => {
          acc.dataset.open = 'false';
          acc.querySelector('.menu-filter__summary')?.setAttribute('aria-expanded', 'false');
          const sublist = acc.querySelector('.menu-filter__sublist');
          if (sublist) sublist.setAttribute('aria-hidden', 'true');
        });
      }
    });
  }
  // ── Menu intro video overlay ──
  (function () {
    var overlay = document.getElementById('nm-intro-overlay');
    var video   = document.getElementById('nm-intro-video');
    var dialog  = document.querySelector('dialog.menu-drawer');
    if (!overlay || !video || !dialog) return;

    var fallback = null;
    var isOpen   = false;

    function showOverlay() {
      clearTimeout(fallback);
      overlay.classList.remove('nm-io-done');
      overlay.classList.add('nm-io-visible');
      video.currentTime = 0;
      video.play().catch(function () { hideOverlay(); });
      fallback = setTimeout(onEnded, 8000);
    }

    function onEnded() {
      clearTimeout(fallback);
      overlay.classList.add('nm-io-done');
      overlay.classList.remove('nm-io-visible');
    }

    function hideOverlay() {
      clearTimeout(fallback);
      video.pause();
      video.currentTime = 0;
      overlay.classList.remove('nm-io-visible');
      overlay.classList.remove('nm-io-done');
    }

    video.addEventListener('ended', onEnded);

    // MutationObserver on dialog[open] — fires reliably on every open/close
    new MutationObserver(function () {
      var nowOpen = dialog.hasAttribute('open');
      if (nowOpen === isOpen) return;
      isOpen = nowOpen;
      if (isOpen) { showOverlay(); } else { hideOverlay(); }
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  })();
  } catch(e) { console.error(e); }
})();

})();
